/**
 * Warm-up de ubicación al entrar al portal del worker (2026-08-04).
 *
 * Decisión usuario: el permiso se pide AL ENTRAR, no al abrir el reporte —
 * así el diálogo nativo sale nada más entrar y el fix está caliente cuando
 * reporta (un GNSS frío bajo plástico tarda 20-40 s en el primer fix). En la
 * app nativa lo dispara el puente de Despia (requestLocationPermission →
 * location://simple); en web, el prompt del navegador.
 *
 * Una sola vez por sesión de pestaña: repetirlo en cada montaje del layout
 * molestaría a quien ya denegó (su bloqueo real se gestiona en el wizard).
 */
import { useEffect } from "react";
import { requestLocationPermission } from "@/lib/geo/locationPermission";

// "done" solo con un resultado CONCLUYENTE (granted/denied): un fallo
// transitorio del puente o del GPS no debe vetar el warm-up para toda la
// sesión de pestaña (hallazgo adversarial 2026-08-04). "pending" evita
// solapar peticiones si el layout se remonta durante la sonda.
let warmupState: "pending" | "done" | null = null;

export function useGeoWarmup() {
  useEffect(() => {
    if (warmupState) return;
    warmupState = "pending";
    void requestLocationPermission().then(
      (result) => {
        warmupState = result === "granted" || result === "denied" ? "done" : null;
      },
      () => {
        warmupState = null;
      },
    );
  }, []);
}
